/**
 * Office file type and product icons from the Fluent UI CDN.
 *
 * Usage per Microsoft CSPP UI guidelines:
 * - File type icons: when displaying a file individually or in a list of files
 * - Product icons: when displaying a button/UI that opens an Office application
 *
 * @see https://learn.microsoft.com/en-us/microsoft-365/cloud-storage-partner-program/online/build-test-ship/ui-guidelines#application-and-file-type-icons
 */

// File Type Icons (for file lists, document displays)
// Source: https://res-1.cdn.office.net/files/fabric-cdn-prod_20260113.001/assets/item-types/20/
import docxIcon from "./assets/docx.svg";
import xlsxIcon from "./assets/xlsx.svg";
import pptxIcon from "./assets/pptx.svg";

// Product Icons (for buttons/UI that opens an Office application)
// Source: https://res-1.cdn.office.net/files/fabric-cdn-prod_20260113.001/assets/brand-icons/product/svg/
import wordProductIcon from "./assets/word-product.svg";
import excelProductIcon from "./assets/excel-product.svg";
import powerpointProductIcon from "./assets/powerpoint-product.svg";
import { cn } from "~/lib/utils";

interface IconProps {
  className?: string;
}

export const WordFileIcon = ({ className }: IconProps) => (
  <img src={docxIcon} className={className} alt="" />
);

export const ExcelFileIcon = ({ className }: IconProps) => (
  <img src={xlsxIcon} className={className} alt="" />
);

export const PowerPointFileIcon = ({ className }: IconProps) => (
  <img src={pptxIcon} className={className} alt="" />
);

export const WordProductIcon = ({ className }: IconProps) => (
  <img src={wordProductIcon} className={cn("size-4", className)} alt="" />
);

export const ExcelProductIcon = ({ className }: IconProps) => (
  <img src={excelProductIcon} className={cn("size-4", className)} alt="" />
);

export const PowerPointProductIcon = ({ className }: IconProps) => (
  <img src={powerpointProductIcon} className={cn("size-4", className)} alt="" />
);
